module.exports = {"gitCommit":"617b4b2","buildDate":"2025-01-16T21:57:13.257Z","context":"/qkr_mss"}


//////////////////
// WEBPACK FOOTER
// ./src/appConfig.json
// module id = 320
// module chunks = 0